(() => {
  const initialiseGallery = (gallery) => {
    const slider = gallery.querySelector('.product_slider');
    const thumbnails = [...gallery.querySelectorAll('[data-gallery-thumbnail]')];

    if (!slider || !thumbnails.length) return;

    const activateThumbnail = (index) => {
      thumbnails.forEach((thumbnail, thumbnailIndex) => {
        const isActive = thumbnailIndex === index;
        thumbnail.classList.toggle('is-active', isActive);
        thumbnail.setAttribute('aria-current', String(isActive));
      });
    };

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        const index = Number(thumbnail.dataset.galleryThumbnail);
        if (window.jQuery && window.jQuery(slider).hasClass('slick-initialized')) {
          window.jQuery(slider).slick('slickGoTo', index);
        }
      });
    });

    if (!window.jQuery) return;

    window.jQuery(slider).on('afterChange.wallpaperGallery', (_event, _slick, currentSlide) => {
      activateThumbnail(currentSlide);
    });
  };

  const initialiseAll = () => {
    document.querySelectorAll('.wallpaper-gallery').forEach(initialiseGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAll, { once: true });
  } else {
    initialiseAll();
  }
})();
